import {
    UserSubscriptionsDocument,
    useUnpauseCurrentSubscriptionMutation,
} from '@lingoda/monolith-graphql';
import { useDispatch } from '@lingoda/hooks';
import { UserSubscriptionsFullDocument } from '../queries.monolith.generated';
import { fetchSubscriptions } from '../actions';

type UseUnpauseSubscriptionOptions = Omit<
    NonNullable<Parameters<typeof useUnpauseCurrentSubscriptionMutation>[0]>,
    'refetchQueries'
>;

export const useUnpauseSubscription = (options: UseUnpauseSubscriptionOptions = {}) => {
    const dispatch = useDispatch();

    const [unpauseMutation, { loading }] = useUnpauseCurrentSubscriptionMutation({
        ...options,
        refetchQueries: [
            UserSubscriptionsDocument, // temporary until we get rid of the old types and queries
            UserSubscriptionsFullDocument,
        ],
        awaitRefetchQueries: true,
        onCompleted(data) {
            // Is used for updating redux store, until we get rid of it completely
            dispatch(fetchSubscriptions());
            options?.onCompleted?.(data);
        },
    });

    return [unpauseMutation, { loading }] as const;
};
